import { urlsWrapper } from 'config';
import {
  saveData,
  RESET_TYPES,
  createCommonItemReducer,
  createCommonItemConstants,
} from './utils';

const constants = createCommonItemConstants('USER_INFO');

// reducer
export default createCommonItemReducer(constants);

// actions
export function getUserInfo() {
  return saveData(
    urlsWrapper('userInfo'),
    constants.SET_ITEM,
    constants.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

// selector
export const getUserInfoSelector = (state) => state.userInfo.item;
